import { render, staticRenderFns } from "./PostHog.vue?vue&type=template&id=1f72d438&scoped=true"
import script from "./PostHog.vue?vue&type=script&lang=ts"
export * from "./PostHog.vue?vue&type=script&lang=ts"
import style0 from "./PostHog.vue?vue&type=style&index=0&id=1f72d438&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f72d438",
  null
  
)

export default component.exports